/**
 * Free Shipping Bar - atualização em tempo real
 * Usa fetch('/cart.js') para subtotal real. Liga-se a eventos do tema.
 */
(function () {
  const THRESHOLD_CENTS = 12500;
  const DEBUG = false; // mudar para true para debug no console

  function log(...args) {
    if (DEBUG) console.log('[FreeShippingBar]', ...args);
  }

  function formatMoney(cents, currency = 'EUR') {
    try {
      return new Intl.NumberFormat('pt-PT', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
      }).format(cents / 100);
    } catch (e) {
      return `${(cents / 100).toFixed(2).replace('.', ',')} €`;
    }
  }

  function updateFreeShippingProgress(cartData) {
    if (!cartData || cartData.total_price == null) return;
    const subtotal = cartData.total_price;
    const currency = cartData.currency || 'EUR';

    const bars = document.querySelectorAll('.free-shipping-bar:not(.free-shipping-bar--empty)');
    if (!bars.length) return;

    const threshold = THRESHOLD_CENTS;
    const remaining = Math.max(threshold - subtotal, 0);
    const progress = Math.min((subtotal / threshold) * 100, 100);
    const displayPercent = subtotal > 0 && progress < 4 ? 4 : progress;

    log('subtotal:', subtotal, 'progress:', progress.toFixed(1) + '%', 'width:', displayPercent + '%');

    const remainingFormatted = formatMoney(remaining, currency);
    const totalFormatted = formatMoney(subtotal, currency);
    const thresholdFormatted = formatMoney(threshold, currency);
    const reached = remaining <= 0;

    bars.forEach((bar) => {
      const thresholdOverride = parseInt(bar.dataset.thresholdCents, 10);
      const t = !isNaN(thresholdOverride) ? thresholdOverride : threshold;
      const rem = Math.max(t - subtotal, 0);
      const prog = Math.min((subtotal / t) * 100, 100);
      const disp = subtotal > 0 && prog < 4 ? 4 : prog;
      const isReached = rem <= 0;

      const textReached = bar.dataset.textReached || 'Conseguiste, muzinha! Tens direito a envio grátis ✨';
      const textProgress = bar.dataset.textProgress || 'Quase lá! Faltam';
      const textEmpty = bar.dataset.textEmpty || 'Adiciona itens ao carrinho para obteres envio grátis';
      const subtext = bar.dataset.subtext || 'Envio grátis em compras acima de';
      const threshFormatted = formatMoney(t, currency);
      const remFormatted = formatMoney(rem, currency);
      const totalF = formatMoney(subtotal, currency);

      const track = bar.querySelector('.free-shipping-bar__track');
      if (track) {
        track.style.setProperty('--fs-progress', disp + '%');
        track.setAttribute('aria-valuenow', Math.round(prog));
      }
      const fill = bar.querySelector('.free-shipping-progress-fill, [data-fs-fill], .free-shipping-bar__fill')
        || (track && track.querySelector('.free-shipping-bar__fill, [data-fs-fill]'));
      if (fill) {
        fill.style.setProperty('width', disp + '%', 'important');
        log('fill width applied:', disp + '%');
      }

      const messageEl = bar.querySelector('.free-shipping-message, [data-fs-title], .free-shipping-bar__title');
      if (messageEl) {
        if (isReached) {
          messageEl.textContent = textReached;
        } else if (subtotal === 0) {
          messageEl.textContent = textEmpty;
        } else {
          messageEl.textContent = `${textProgress} ${remFormatted} para envio grátis`;
        }
      }

      const subtextEl = bar.querySelector('[data-fs-subtext], .free-shipping-bar__subtext');
      if (subtextEl) subtextEl.textContent = `${subtext} ${threshFormatted}`;

      const valueEl = bar.querySelector('.free-shipping-value, [data-fs-values], .free-shipping-bar__values');
      if (valueEl) valueEl.textContent = `${totalF} / ${threshFormatted}`;

      bar.classList.toggle('free-shipping-bar--reached', isReached);
    });
  }

  function fetchAndUpdateFreeShippingProgress() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        log('cart.js response total_price:', cart.total_price);
        updateFreeShippingProgress(cart);
      })
      .catch((e) => log('fetch cart.js error:', e));
  }

  function scheduleUpdate(delay = 400) {
    clearTimeout(window._fsbUpdateTimer);
    window._fsbUpdateTimer = setTimeout(fetchAndUpdateFreeShippingProgress, delay);
  }

  function isOnCartPage() {
    return !!document.getElementById('cart');
  }

  function init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.cartData) {
        updateFreeShippingProgress(event.cartData);
      } else {
        scheduleUpdate(300);
      }
    });

    document.addEventListener('click', (e) => {
      if (isOnCartPage()) return;
      const btn = e.target.closest('.quantity__button');
      if (btn && (e.target.closest('cart-items') || e.target.closest('cart-drawer-items'))) {
        scheduleUpdate(800);
      }
    });

    document.addEventListener('change', (e) => {
      if (isOnCartPage()) return;
      const input = e.target;
      if (
        input?.type === 'number' &&
        (input.classList?.contains('quantity__input') || input.closest('quantity-input')) &&
        (input.closest('cart-items') || input.closest('cart-drawer-items'))
      ) {
        scheduleUpdate(800);
      }
    });

    if (document.querySelector('.free-shipping-bar')) {
      scheduleUpdate(100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.updateFreeShippingProgress = updateFreeShippingProgress;
  window.fetchAndUpdateFreeShippingProgress = fetchAndUpdateFreeShippingProgress;
})();
